exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var getUrl = require("../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL___0___ = getUrl(require("./Pangram-Light.otf"));
var ___CSS_LOADER_URL___1___ = getUrl(require("./Pangram-Regular.otf"));
var ___CSS_LOADER_URL___2___ = getUrl(require("./bahnschrift.ttf"));
// Module
exports.push([module.id, "@font-face{font-family:Pangram;font-weight:300;src:url(" + ___CSS_LOADER_URL___0___ + ") format(\"opentype\")}@font-face{font-family:Pangram;font-weight:400;src:url(" + ___CSS_LOADER_URL___1___ + ") format(\"opentype\")}@font-face{font-family:Bahnschrift;src:url(" + ___CSS_LOADER_URL___2___ + ") format(\"truetype\")}a{text-decoration:none;color:inherit}", ""]);
